
export enum LogoutCauses {
	Expiration = 'expiracion',	// La sesión del usuario ha vencido
	WithoutLogin = 'sinlogin',	// Un usuario desea acceder a una url del sitio sin haber realizado un login
	Cancelled =  'cancelada'	// El usuario ha decidido finalizar la sesión
}